import React from 'react';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'lib/components/ui/hero';
import Pricing from 'modules/Marketing/components/Pricing';
import Highlight from 'modules/common/components/Highlight';
import { Button } from 'lib/components/ui/button';
import { useAuthModal } from 'modules/auth';
import { Section } from '@/lib/components/layout/section';

const AbonnementPage = () => {
  const { signin } = useAuthModal();

  return (
    <HeaderLayout title="Abonnement" description="Découvrez nos formules d'abonnement Headlinker">
      <Hero
        meta="Rejoins 400+ recruteurs qui augmentent leurs revenus"
        title={
          <>
            <Highlight>Multiplie</Highlight> tes placements
            <br />
            sans effort supplémentaire
          </>
        }
        description={
          <>
            Accède à une communauté exclusive de recruteurs, partage tes candidats non retenus, trouve des missions pour tes clients difficiles, et{' '}
            <strong>augmente tes revenus</strong> grâce à notre réseau de confiance.
          </>
        }
        cta={
          <div className="flex flex-col gap-4 items-center">
            <Button variant="cta" size="lg" onClick={() => signin()}>
              Postule gratuitement
            </Button>
            <div className="text-sm text-gray-600">✓ Sans engagement ✓ Communauté vérifiée ✓ Support inclus</div>
          </div>
        }
      />
      <Section title="Choisis ta formule" variant={'boxed'}>
        <Pricing className="mt-5" />
      </Section>
    </HeaderLayout>
  );
};

export default AbonnementPage;
